export const getNumberOfDaysInMonth = (year: number, month: number): number => {
  const d = new Date(year, month + 1, 0)
  return d.getDate()
}

export const isToday = (year: number, month: number, day: number): boolean => {
  const today = new Date()
  return today.getFullYear() === year && today.getMonth() === month && today.getDate() === day
}